var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntersex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M247.776 0V57.674H324.361L254.914 127.121C238.623 117.626 219.681 112.182 199.466 112.182C138.559 112.182 89.184 161.557 89.184 222.464C89.184 273.393 123.709 316.25 170.629 328.929V392.153H108.738V449.827H170.629V512H228.303V449.828H290.194V392.154H228.303V328.93C275.223 316.252 309.748 273.394 309.748 222.465C309.748 202.713 304.55 184.178 295.456 168.142L365.142 98.456V175.041H422.816V0H247.776ZM199.466 283.883C165.545 283.883 138.047 256.385 138.047 222.464C138.047 188.543 165.545 161.045 199.466 161.045C233.387 161.045 260.885 188.543 260.885 222.464C260.885 256.385 233.386 283.883 199.466 283.883Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntersex);
export default __webpack_public_path__ + "static/media/Intersex.9b5ba2d60004d0cf639887d6b595bc6c.svg";
export { ForwardRef as ReactComponent };